// Split out of LoginPage.jsx: react-refresh/only-export-components flags any
// non-component export colocated with a page component, and only scans
// .jsx/.tsx files, so a plain .js constants module is exempt.
export const SESSION_CHECK_TIMEOUT_MS = 8_000;
